// useSelectedMenu.js (Custom Hook for state management)
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { findRouteDetails, pathMatches } from "../helper/com-helper";
import { BAR_MENU } from "../utils/const";

const findSelectedBarMenu = (route) => {
    for (let key in BAR_MENU) {
        const item = BAR_MENU[key];
        if (item?.childrenRoutes?.some((children) => pathMatches(children, route))) {
            return { ...item, parent: key };
        }
    }
    return {};
};

// { parent, menu, subMenu } for a route - product, module and sub-module in menu terms.
export const getSelectedMenu = (route) => findRouteDetails(route, findSelectedBarMenu(route));

export const useSelectedMenu = () => {
    const location = useLocation();

    // Derived synchronously off the current route (useMemo, not
    // useState+useEffect) so there's no first-paint frame where
    // selectedMenu is still {parent: null, ...} after a refresh.
    const selectedMenu = useMemo(() => getSelectedMenu(location.pathname), [location.pathname]);

    return { selectedMenu };
};
